const body = document.querySelector('body');
const home = body.classList.contains('home');



if (home && (window.innerWidth > 1200)) {

    const header = document.getElementById('header');
    const alu = document.querySelectorAll('.home-slideshow')[0];
    const events = document.querySelectorAll('.events')[0];
    const news = document.querySelectorAll('.news')[0];
    const access = document.querySelectorAll('.access')[0];
    const kiosque = document.querySelectorAll('.kiosque')[0];


    function offset(el) {
        let rect = el.getBoundingClientRect(),
            scrollTop = window.scrollY || document.documentElement.scrollTop,
            halfHeight = rect.height / 2;
        return {top: rect.top + scrollTop - halfHeight}
    }

    let eventsPosition = offset(events);
    let newsPosition = offset(news);
    let accessPosition = access.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop) - 830 ;
    let kiosquePosition = offset(kiosque);


    document.addEventListener("DOMContentLoaded", (event) => { 
    
        setTimeout(function() {
            header.classList.add('js-header-init');
        }, 500);

        setTimeout(function() {
            alu.classList.add('js-home-slideshow-init');
        }, 1200);
    });

    window.addEventListener('scroll', function () {
        /* console.log(accessPosition)
        console.log(window.scrollY) */
        if (window.scrollY > eventsPosition.top) {
            events.classList.add('js-events-init');
        }
        if (window.scrollY > newsPosition.top) {
            news.classList.add('js-news-init');
        }
        if (window.scrollY > accessPosition) {
            access.classList.add('js-access-init');
        }
        if (window.scrollY > kiosquePosition.top) {
            kiosque.classList.add('js-kiosque-init');
        }
    })
}
